module.exports = [{"name":"Cylinder","img":"circle.png","file":"circle","author":"William CLOT","description":"Default cylinder stand","scale":1},{"name":"Hexagone","img":"hexagone.png","file":"hexagone","author":"William CLOT","description":"Default cylinder stand","scale":1}]


//////////////////
// WEBPACK FOOTER
// ./src/library/stands.json
// module id = 247
// module chunks = 0